import { render, staticRenderFns } from "./ReportConfirmationDialog.vue?vue&type=template&id=2e196232&scoped=true&"
import script from "./ReportConfirmationDialog.vue?vue&type=script&lang=ts&"
export * from "./ReportConfirmationDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ReportConfirmationDialog.vue?vue&type=style&index=0&id=2e196232&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e196232",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VDialog})
